import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCenterAlign = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 9,
	viewBox: "0 0 16 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2 8.25C2 8.66421 2.33579 9 2.75 9H13.25C13.6642 9 14 8.66421 14 8.25C14 7.83579 13.6642 7.5 13.25 7.5H2.75C2.33579 7.5 2 7.83579 2 8.25ZM0.75 0C0.335786 0 0 0.335786 0 0.75C0 1.16421 0.335786 1.5 0.75 1.5H15.25C15.6642 1.5 16 1.16421 16 0.75C16 0.335786 15.6642 0 15.25 0H0.75ZM3.5 4.5C3.5 4.91421 3.83579 5.25 4.25 5.25H11.75C12.1642 5.25 12.5 4.91421 12.5 4.5C12.5 4.08579 12.1642 3.75 11.75 3.75H4.25C3.83579 3.75 3.5 4.08579 3.5 4.5Z",
		fill: "#363F5A"
	})]
});
const ForwardRef = forwardRef(SvgCenterAlign);
export default ForwardRef;
